/**
 * @file 事件总线
 * @author focusteach(focusteach@focusteach.com)
 */

import Vue from 'vue';

// 全局事件总线
export default new Vue();
